/**
 * What the site reads from a release.
 *
 * The release job publishes https://download.warg.dev/mac/latest.json, the feed the app's updater reads:
 *   { "version": "0.1.0", "notes": "…", "pub_date": "…", "platforms": { "darwin-aarch64": { "signature": "…", "url": "…" } } }
 * The site reads one field from it:
 *   version   "x.y.z", digits only: no "v" prefix, no pre-release or build suffix. Anything else reads as no release.
 * The Worker answers GET /api/latest with { "available": true, "version": "x.y.z" } when that file exists and its
 * version is valid, and { "available": false } otherwise. notes, pub_date and platforms are not passed on.
 */
export interface Latest {
  available: boolean;
  version?: string;
}

export const RELEASE_VERSION = /^\d{1,4}\.\d{1,4}\.\d{1,4}$/;

/** The one check both sides use: the Worker before it says a release exists, the page before it shows a version. */
export function isReleaseVersion(v: unknown): v is string {
  return typeof v === 'string' && RELEASE_VERSION.test(v);
}

/** True only for an /api/latest answer that names a real release. */
export function isAvailable(latest: unknown): latest is Latest & { version: string } {
  return !!latest && typeof latest === 'object' && (latest as Latest).available === true && isReleaseVersion((latest as Latest).version);
}
